export function nestedAccess(path, obj) {
  return path.split('.').reduce(
    (prev, curr) => (prev ? prev[curr] : undefined),
    // eslint-disable-next-line no-restricted-globals
    obj || self
  );
}

export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function isEqual(obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export function keep(obj, keys) {
  const result = {};
  keys.forEach(key => {
    result[key] = obj[key];
  });
  return result;
}
